import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
`

export const Container = styled.div`
  max-width: 400px;
  margin: 0 auto;
`